import React from "react";
import Skeleton from "../ui/Skeleton";

/**
 * Espelha o layout de /organization: cabeçalho com abas, três indicadores e o card
 * de pendências da aba "Visão geral".
 */
export const OrganizationSkeleton: React.FC = () => {
  return (
    <div className="w-full space-y-3 animate-pulse">
      {/* Cabeçalho + abas */}
      <div className="bg-white border border-purple-200 rounded-3xl shadow-xl shadow-gray-200/20 overflow-hidden">
        <div className="h-1.5 bg-purple-100" />
        <div className="px-4 sm:px-5">
          <div className="flex items-center gap-3 pt-3">
            <Skeleton
              width={48}
              height={48}
              className="shrink-0 rounded-xl bg-purple-50"
            />
            <div className="flex-1 min-w-0 space-y-2">
              <Skeleton variant="text" width={220} height={20} />
              <div className="flex flex-wrap gap-1.5">
                {[150, 110, 160, 140].map((w) => (
                  <Skeleton
                    key={w}
                    width={w}
                    height={24}
                    className="rounded-lg opacity-70"
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-3 -mx-4 sm:-mx-5 px-2 sm:px-3 border-t border-purple-100 flex gap-2 py-3">
            {[96, 150, 116, 104].map((w) => (
              <Skeleton
                key={w}
                width={w}
                height={20}
                className="rounded-md opacity-70"
              />
            ))}
          </div>
        </div>
      </div>

      {/* Indicadores */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="bg-white rounded-xl border border-purple-200 p-4 shadow-sm space-y-3"
          >
            <div className="flex items-start justify-between">
              <div className="space-y-2">
                <Skeleton variant="text" width={120} height={10} />
                <Skeleton variant="text" width={70} height={26} />
              </div>
              <Skeleton width={36} height={36} className="rounded-lg" />
            </div>
            <Skeleton height={26} className="rounded-lg opacity-60" />
          </div>
        ))}
      </div>

      {/* Pendências */}
      <div className="bg-white border border-purple-200 rounded-3xl shadow-xl shadow-gray-200/20 p-3 sm:p-4">
        <div className="flex items-start gap-3 border-b border-purple-100 pb-2 mb-3">
          <Skeleton width={40} height={40} className="rounded-xl" />
          <div className="space-y-2 pt-0.5">
            <Skeleton variant="text" width={110} height={14} />
            <Skeleton variant="text" width={220} height={10} />
          </div>
        </div>
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton width={32} height={32} className="rounded-lg" />
              <div className="flex-1 space-y-1.5">
                <Skeleton variant="text" width="30%" height={12} />
                <Skeleton variant="text" width="60%" height={10} />
              </div>
              <Skeleton width={96} height={30} className="rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrganizationSkeleton;
